"use client";

import { HtmlSitemap } from "@/graphql/queries/sitemap-html-query";
import Section from "../components/Section";
import { Box, RenderIf, Typography } from "@repo/ui";
import Link from "next/link";
import BreadcrumbsLink from "@/components/common/BreadcrumbsLink";
import { useMemo } from "react";
import { useParams } from "next/navigation";
import clsx from "clsx";

type SitemapProps = HtmlSitemap;

export default function Sitemap({ sitemaps, links }: SitemapProps) {
  const { country } = useParams<{ country: string }>();
  const countryName = useMemo(() => {
    if (!links) return;
    return links[0]?.label;
  }, [links]);
  const breadcrumbs = [
    {
      label: "Home",
      url: country ? `/${country}/` : "/",
    },
    {
      label: countryName ? `${countryName} Sitemap` : " Sitemap",
      url: null,
    },
  ];
  return (
    <Section>
      <BreadcrumbsLink breadcrumbs={breadcrumbs} className="absolute top-4" />
      <Box className="text-center">
        <Typography variant="h1" gutterBottom>
          {countryName} Sitemap
        </Typography>
      </Box>
      {links?.map((item, index) => (
        <Typography
          key={`sitemaps-links-${index}`}
          variant="h2"
          className="text-blue-700 block py-3 hover:underline"
          render={<Link href={item.url} />}
        >
          {item.label}
        </Typography>
      ))}
      {sitemaps?.map((item, index) => (
        <RenderIf
          key={`sitemap-${item.title}-${index}`}
          condition={item.links.length > 0}
        >
          <Box className="mt-3">
            <Box>
              <Typography variant="h2" className="text-primary-main">
                {item.title}
              </Typography>
            </Box>

            <Box className="py-5">
              <ul
                className={clsx("sm:columns-3", {
                  "columns-2":
                    item.title === "Country Home" ||
                    item.title === "Country Pages" ||
                    item.title === "Others",

                  "sm:!columns-2": countryName !== undefined,
                })}
              >
                {item?.links.map((litem, index) => (
                  <li key={`link-item-${index}`}>
                    <Link
                      href={litem.url}
                      className="text-blue-700 hover:underline py-1 block"
                    >
                      {litem.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </Box>
          </Box>
        </RenderIf>
      ))}
    </Section>
  );
}
